<!-- joinUs -->
<template>
  <div class="joinUs">
    <div class="bgBox section1 ">
      <div class="s1_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>加入</span>我们
          </div>
          <div class="p2"></div>
          <div class="p3">JOIN US</div>
          <div class="p4">
            人才招聘
          </div>
          <div class="p5">
            <div class="phoneBox">
              <img src="../../static/images/contact/服务热线.png" alt="">
              <span>+86 0755-29128850 / +86 134 1007 8672</span>
            </div>
            <div class="emailBox">
              <img src="../../static/images/contact/邮箱.png" alt="">
              <span>hr@levimelt.com</span>
            </div>
          </div>
        </div>
        <div class="bodyBox">
          <div class="item" :class="active==1?'active':''" @click="section1Func(1)">技术工程师</div>
          <div class="item" :class="active==2?'active':''" @click="section1Func(2)">销售经理</div>
          <div class="item" :class="active==3?'active':''" @click="section1Func(3)">采购管理</div>
          <div class="item" :class="active==4?'active':''" @click="section1Func(4)">行政/综合</div>
        </div>
      </div>
    </div>
    <div class="bgBox sectionItem " v-for="(data,index) in obj[active]" :key="data.name">
      <div class="innerBox typeArea">
        <div class="commBox" :class="(index+1)%2==0?'right':''">
          <div class="labelBox">
            <div class="span">
              {{data.name}}
            </div>
            <div class="line"></div>
          </div>
          <div class="contentBox">
            <div class="tips">岗位职责：</div>
            <div class="item" v-for="item1 in data.items1" :key="item1">{{item1}}</div>

            <div class="tips cons">任职资格：</div>
            <div class="item" v-for="item2 in data.items2" :key="item2">{{item2}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'joinUs',
    components: {},
    data() {
      return {
        active: 1,
        obj: {
          1: [{
            name: '真空熔炼设备结构设计工程师',
            items1: [
              "1. 负责组织真空设备产品结构设计研发；", "2. 负责真空设备方案设计；", "3. 负责指导、参与真空设备结构设计，标准件选型工作；", "4. 负责组织结构研发技术攻关；",
              "5. 指导设备的装配、试制工作并编制安装工艺文件；", "6. 负责组织处理客户转产技术问题。"
            ],
            items2: [
              "1. 本科及以上学历，机械设计及自动化、机电一体化、材料加工等相关专业；",
              "2. 具有较强的机械设计理论水平，熟练使用Solidworks、Auto-CAD等机械设计软件；",
              "3. 具备丰富的真空专业知识，熟悉工艺、材料；",
              "4. 5年以上真空设备、流体机械设计经验；",
              "5. 有主持单体与连续线真空设备研发项目经验者优先考虑。",
            ]
          }, {
            name: '机械加工工艺工程师',
            items1: [
              "1. 负责产品的生产工艺的设计、评审验证；",
              "2. 图纸审核校对；",
              "3. 编制作业指导书等工艺文件；",
              "4. 编制零组件工艺（零件主要加工工艺包括下料、车加工、铣加工、激光切割、折弯、去毛刺、标印、检验、入库等；组件加工工艺主要包括备件、清洗、预装、真空钎焊、氩弧焊接、铜焊、车加工/铣加工、去毛刺、空气密封、检验、入库等）；",
              "5. 制定生产工艺并跟进工厂加工生产；",
              "6. 对现有生产工艺进行改善以提高生产效率；",
              "7. 能独立操作现切割。",
            ],
            items2: [
              "1. 本科及以上学历，车辆工程、机械制造、工业设计等相关专业；",
              "2. 3年以上工作经验，汽车零部件行业工艺工程师经验优先；",
              "3. 熟练使用一种3D设计软件；",
              "4. 能进行简单的工装夹具设计；",
              "5. 思路清晰，思维缜密；具备良好的团队管理能力及协作精神，工作积极主动，执行力强。",
            ]
          }, {
            name: '真空熔炼工程师',
            items1: [
              "1. 负责组织真空设备熔炼生产；",
              "2. 维修保养真空熔炼设备。",
            ],
            items2: [
              "1. 本科及以上学历，金属材料与工艺设备等相关专业；",
              "2. 熟悉物理冶金技术与工艺方法，特别是真空熔炼技术经验；",
              "3. 具备丰富的真空专业知识，熟悉工艺、材料；",
              "4. 3年以上专业工作经验；",
              "5. 具有真空熔炼设备的维护和使用能力。",
            ]
          }],
          2: [{
              name: '销售经理',
              items1: [
                "1. 积极主动按计划开展各项销售工作和并努力完成公司下达的销售指标（材料方向、真空悬浮熔炼设备等）；",
                "2. 独立开发新客户和跟踪老客户（设备：真空悬浮设备；材料：高熵合金、靶材、复合集流体的），保证新客户开发数量和质量；",
                "3. 全面了解潜在客户需求，准确把握项目各阶段进展等；",
                "4. 收集整理分析市场信息，了解潜在客户需求，协助公司提升竞争优势；",
                "5. 实时把握市场发展和客户需求，定期向公司提供销售分析及预测报告，定期组织安排厂家和技术人员客户走访",
                "6. 根据公司发展的需要，不断学习新知识与新技术，提升自身的专业能力与职业。",
              ],
              items2: [
                "1. 专科及以上学历，理工科优先，具备日常英文读写能力优先；",
                "2. 必须具备真空悬浮熔炼设备等销售经验或高熵合金、靶材、复合集流体等销售经验；",
                "3. 了解金属/氧化物等新材料研发设备/工艺设备/检测设备类优先；",
                "4. 了解半导体工艺设备/封装设备/检测设备类优先，其次或者做过大型仪器设备等也考虑。",
              ]
            },
            {
              name: '销售助理',
              items1: [
                "1. 负责真空机械设备产品的渠道开拓及市场销售工作；",
                "2. 为客户提供非标设备专业技术支持；",
                "3. 开发新客户，维护良好的客户关系，扩大产品的市场占有率；",
                "4. 完成销售业务目标；",
                "5. 能独立完成销售、售后等相关合同编制及审查；",
                "6. 负责上级分配的其他任务。",
              ],
              items2: [
                "1. 30岁以下，无专业要求，有驾照能开车，具有较强的责任心，吃苦耐劳，好学，能快速掌握设备知识；",
                "2. 形象好，气质佳，沟通能力强，熟悉商务礼节；",
                "3. 有真空设备销售经验者优先；",
                "4. 有金属材料相关科研资源者优先；",
                "5. 熟悉国家及行业标准制；",
                "6. 具备一定视频剪辑能力者优先。",
              ]
            }
          ],
          3: [{
            name: '采购管理',
            items1: [
              "1. 独立进行供应商寻找，评估，认可和改进工作；",
              "2. 识别合格的供应商或开发新的供应商以执行采购活动(询价，谈判，签约等)；",
              "3. 报价分析，交易条款和条件的谈判，供应商定点；",
              "4. 与供应商和内部部门协调，澄清要求和质量问题；",
              "5. 创建订单并处理发货状态，确保按时发货；",
              "6. 项目管理，制定项目计划、里程碑、跟踪清单并及时更新，随时满足项目需求；",
              "7. 管理与供应商的关系，推动在成本、交货、质量和服务的持续改进；",
              "8. 维护采购数据(供货来源、供货条件、采购联系人等)，保持日常监控和更新；",
              "9. 管理和归档日常工作中的文件，确保符合法律要求和公司政策。",
            ],
            items2: [
              "1. 专科及以上学历，理工科优先，具备日常英文读写能力优先；",
              "2. 良好的项目管理、价格谈判和数据分析能力；",
              "3. 有项目管理经验者优先；",
              "4. 3年及以上机械行业销售经验，有独立开发供应商能力；",
              "5. 了解金属/氧化物等新材料研发设备/工艺设备/检测设备类优先。",
            ]

          }],
          4: [{
            name: '行政/综合',
            items1: [
              "1. 网络运行维护；",
              "2. 公司整体办公设备维护；",
              "3. 各类办公软件、设计软件等管理；",
              "4. 视频剪辑、数字化内容创作、运营、创意设计的输出和管理工作；",
              "5. 负责主流社交平台及媒体运营；",
              "6. 协助行政处理日常工作;",
              "7. 直线上级或者管理层委派的其他工作。",
            ],
            items2: [
              "1. 本科及以上学历；",
              "2. 优秀的沟通能力和协调能力；具备日常英文读写能力优先；",
              "3. 文笔优秀，有较强的信息收集、材料整理、独立研究能力；",
              "4. 机械行业推广者优先。",
            ]
          }]
        }
      }
    },
    computed: {},
    watch: {},
    created() {
      this.init()
    },
    mounted() {
      this.$store.commit('savePageId','')
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    methods: {
      init() {

      },
      section1Func(data) {
        this.active = data
      }
    },
  }

</script>

<style lang='less' scoped>
  .joinUs {
    width: 100%;
    min-width: 1200px;

    .section1 {
      width: 100%;
      height: 614px;

      .s1_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 193px
          }

          .p4 {
            font-size: 16px;
            color: #333333;
            line-height: 16px;
            font-weight: 400;
            margin-top: 76px;
          }

          .p5 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 44px;
            background-color: #c30000;
            padding: 0 15px;
            color: #ffffff;
            font-size: 20px;
            font-weight: 400;
            margin-top: 22px;

            .phoneBox,
            .emailBox {
              display: flex;
              align-items: center;
              img {
                margin-right: 8px;
              }
            }
            .emailBox{
              margin-left: 50px;
            }
          }
        }

        .bodyBox {
          display: flex;
          margin-top: 59px;
          position: relative;

          .item {
            width: 300px;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            color: #545454;
            font-weight: 400;
            background-color: #fbfbfb;
            cursor: pointer;
          }

          .item.active {
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
            border: solid 1px #c30000;
            background-color: #ffffff;
            color: #c30000;
            font-weight: bold;
          }
        }
      }
    }

    .commBox {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .labelBox {
        width: 350px;
        height: 350px;
        border: solid 2px #c30000;
        padding: 18px 30px;
        font-size: 34px;
        line-height: 52px;
        color: #545454;
        text-align: left;
        margin-top: 100px;
        font-weight: 700;

        .line {
          width: 64px;
          height: 4px;
          background-color: #c30000;
          margin-top: 16px;
        }
      }

      .contentBox {
        width: 822px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        padding: 20px;
        font-weight: 400;
        margin-top: 178px;
        text-align: left;
        .tips {
          font-size: 18px;
          color: #333333;
          line-height: 30px;

        }
        .item{
          color: #545454;
          font-size: 16px;
          line-height: 28px;
        }
        .cons {
          margin-top: 30px;
        }

        .item1 {
          font-size: 16px;
          line-height: 24px;
          color: #545454;
        }
      }
    }

    .commBox.right {
      flex-direction: row-reverse;
    }

    .sectionItem {
      width: 100%;
      height: 400px;
      background-color: #fbfbfb;
      margin-bottom: 400px;

      .innerBox {
        height: 100%;

      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/joinUs.vue